import { type BlockConfiguration, registerBlockType } from '@wordpress/blocks';

import metadata from './block.json';
import { DownloadsEdit } from './edit';
import { Icon } from './icon';
import type { DownloadsAttributes } from './types';

registerBlockType( metadata.name, {
	...( metadata as BlockConfiguration< DownloadsAttributes > ),
	icon: Icon,
	edit: DownloadsEdit,
} );
